import { googleAnalyzeEvent } from "@/types/googleAnalyzeEvent";
import ReactGa from "react-ga4";

import type { GoogleAnalyzeEventType } from "@/types/googleAnalyzeEvent";

export type GTagEventSendConfig<TItems> = {
  currency?: string,
  items?: TItems
} & {
  [key: string]: any; // 允许GTagEventSendConfig包含任意额外的属性
};

export type GTagEventSend<TItems> = [GoogleAnalyzeEventType | null | undefined, GTagEventSendConfig<TItems>] | [];

export interface IUseGTagEvent {
  sendEvent: <TItems>(...args: GTagEventSend<TItems>) => void;
}

const useGTagEvent: () => IUseGTagEvent = () => {

  const sendEvent: IUseGTagEvent['sendEvent'] = (...args) => {
    const [eventType, ..._args] = args;

    typeof eventType === 'string' ?
      ReactGa.gtag('event', googleAnalyzeEvent.get(eventType), ..._args) :
      ReactGa.gtag('event', ...args);
  }

  return { sendEvent };
}

export default useGTagEvent;
